/* eslint-disable no-param-reassign */
export default class ImageFallback {
    constructor() {
        this.containers = [...document.querySelectorAll('*[data-image-fallback-container]')];
        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((e) => {
                this.setFallbackImage(e.target);
            });
        });
        this.init();
        this.bind();
    }

    bind() {
        this.containers.forEach((e) => {
            this.observer.observe(e, {
                subtree: true,
                childList: true,
            });
        });
    }

    init() {
        this.setFallbackImage(document);
    }

    // eslint-disable-next-line class-methods-use-this
    setFallback(image, status, path) {
        if (!status) {
            return;
        }
        const parentPicture = image.closest('picture');

        if (parentPicture) {
            const sources = parentPicture.querySelectorAll('source');
            sources.forEach((source) => {
                if (source.srcset) {
                    source.srcset = path;
                }
            });
        }
        image.src = path;
    }

    setFallbackImage(el) {
        const imageFallback = [...el.querySelectorAll('*[data-image-fallback]')];

        imageFallback?.forEach((img) => {
            const fallbackPath = img.dataset.imageFallback;
            if (!fallbackPath) {
                return;
            }
            if (!img.complete) {
                img.addEventListener('error', () => this.setFallback(img, true, fallbackPath), { once: true });
            } else if (img.naturalHeight === 0 || img.naturalWidth === 0) {
                this.setFallback(img, true, fallbackPath);
            }
        });
    }
}

if (document.querySelector('[data-image-fallback-container]')) {
    // eslint-disable-next-line no-unused-vars
    const imageFallback = new ImageFallback();
}
